angular.module('homebot.directives')

  .directive('nightlyRentalSingle', ['Dictionary', 'UtilService', function(Dictionary, utils){
    return {
      restrict: 'A',
      controllerAs: 'nightlySingleCtrl',
      bindToController: {
        learnMoreAction: '&',
        loans: '=',
        payment: '@',
        rentalNights: '@',
        potential: '=',
        title: '@',
      },
      scope: {},

      templateUrl: function(el, attrs){
        if(attrs.nightlyDataType === 'airdna')
          return '/homes/templates/partials/nightly-rental.html';

        return '/homes/templates/partials/nightly-rental-static-single.html';
      },

      controller: function(){
        var loans;
        var dictionary = new Dictionary();
        var ctrl = this;

        ctrl.currentChart = 'monthlyRevenue';
        ctrl.monthlyEarnings = 1;

        if(ctrl.potential){
          ctrl.rentalNightsMax = ctrl.potential.occupancy.ltm * 30;
          ctrl.paymentMax = ctrl.potential.adr.ltm;
          ctrl.rentalNights = ctrl.rentalNightsMax * .4;
          ctrl.payment = ctrl.paymentMax * .7;
        }

        function getCorrectLoan(){
          return [dictionary.highestRateLoan({loans: ctrl.loans})];
        };

        ctrl.lookup = function(prop,args,home){
          if(!loans || !loans.length) return '';

          home = home || {loans: loans};
          return dictionary[prop](home,args);
        };

        ctrl.update = function(){
          loans = getCorrectLoan();
        };

        ctrl.occupancyPercentage = function(){
          return ctrl.rentalNights / ctrl.rentalNightsMax;
        };

        ctrl.nightlyRatePercentage = function(){
          return ctrl.payment / ctrl.paymentMax;
        };

        ctrl.monthlyRevenuePercentage = function(){
          return 1 * ctrl.occupancyPercentage() * ctrl.nightlyRatePercentage();
        };

        ctrl.calculatePercentage = function(){
          if(ctrl.currentChart === 'monthlyRevenue') return ctrl.monthlyRevenuePercentage();
          if(ctrl.currentChart === 'nightlyRate') return ctrl.nightlyRatePercentage();
          if(ctrl.currentChart === 'monthlyOccupancy') return ctrl.occupancyPercentage();
        };

        ctrl.updateEarnings = function(){
          if(ctrl.potential){
            ctrl.monthlyEarnings = ctrl.potential.revenue.ltm * ctrl.monthlyRevenuePercentage() / 12;
            ctrl.annualEarnings = ctrl.potential.revenue.ltm * ctrl.monthlyRevenuePercentage();
          }else{
            ctrl.monthlyEarnings = ctrl.payment * ctrl.rentalNights;
          }
        };
      },

      link: function($scope, el, attrs, ctrl){
        $scope.$watchCollection('nightlySingleCtrl.loans', ctrl.update);
        $scope.$watch('nightlySingleCtrl.payment', ctrl.updateEarnings);
        $scope.$watch('nightlySingleCtrl.rentalNights', ctrl.updateEarnings);
      }
    }

  }]);
